// removed by extract-text-webpack-plugin
module.exports = {"youtubeWrapper":"youtubeWrapper--1V4fH","placeholder":"placeholder--1VWFA","placeholderContents":"placeholderContents--3b_rz","headline":"headline--i4mwU","hide":"hide--28yEk"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/YoutubePlayer/index.scss
 ** module id = 175
 ** module chunks = 17 23 27 29 30
 **/